import { Command } from 'commander';
import { createConnectGuideCommand } from './guide.js';
import { createConnectListCommand } from './list.js';
import { createConnectShowCommand } from './show.js';
import { createConnectPolicyCommand } from './policy.js';
import { createConnectDbCommand } from './db/index.js';
import { createConnectCacheCommand } from './cache/index.js';

export function createConnectCommand(): Command {
    const cmd = new Command('connect')
        .alias('cx')
        .description('Environment-aware connection tools for database and cache');

    cmd.addCommand(createConnectGuideCommand());
    cmd.addCommand(createConnectListCommand());
    cmd.addCommand(createConnectShowCommand());
    cmd.addCommand(createConnectPolicyCommand());
    cmd.addCommand(createConnectDbCommand());
    cmd.addCommand(createConnectCacheCommand());

    cmd.action(async () => {
        const { createConnectGuideCommand: guideCmd } = await import('./guide.js');
        const guide = guideCmd();
        await guide.parseAsync([], { from: 'user' });
    });

    return cmd;
}

